import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Toast, ToastsManager } from 'ng2-toastr';
import { Consultant } from '../../../models/Consultant.model';
import { ConsultantSearch } from '../../../models/ConsultantSearch.model';
import { DropDownList } from '../../../models/DropDownList.model';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { ConsultantService } from '../../../services/consultant.service';
import { CommonHelper } from '../../helpers/CommonHelper';
import { ErrorHandlerProvider } from '../../providers/errorHandler.provider';

@Component({
    selector: 'app-self-fill-modal',
    templateUrl: './self-fill-modal.component.html',
    styleUrls: ['./self-fill-modal.component.scss']
})

export class SelfFillModalComponent implements OnInit {
    @ViewChild('massFormRequest') massFormRequest: ElementRef;
    @Input() excellenceCenters: Array<ExcellenceCenter>;
    loading: boolean = false;
    centerConsultants = new Array<DropDownList>();
    selectedCenterConsultants: DropDownList[] = new Array<DropDownList>();
    centerConsultantsSettings = {}
    selectedCenter: string;
    consultantSearch = new ConsultantSearch();
    consultants = new Array<Consultant>();
    isConsultantsEmpty: boolean = true;
    isMassRequest: boolean = false;
    isAnyCenterSelected: boolean = false;
    constructor(
        public commonHelper: CommonHelper,
        private consultantService: ConsultantService,
        private errorHandler: ErrorHandlerProvider,
        private toastr: ToastsManager
    ) { }

    async ngOnInit() {
        this.centerConsultantsSettings = this.commonHelper.getDropDownSettings(
            false,
            'Consultores',
            true,
            'Marcar todos os consultores',
            'Desmarcar todos os consultores',
            true,
            null,
            ''
        );
    }

    async onChangeCenter(): Promise<void> {
        try {
            this.isMassRequest = false;
            if (this.selectedCenter === 'undefined' || this.selectedCenter === undefined) {
                this.centerConsultants = [];
                this.selectedCenterConsultants = [];
                this.isAnyCenterSelected = false;
                return;
            }
            this.loading = true;
            this.isAnyCenterSelected = true;
            this.selectedCenterConsultants = [];
            this.consultantSearch.excellenceCenter = [];
            this.centerConsultants = [];
            this.consultantSearch.excellenceCenter.push(this.selectedCenter);
            this.consultantSearch.limit = 0;
            this.consultantSearch.skip = 0;
            const response = await this.consultantService.searchConsultants(this.consultantSearch);
            if (response && response.length) {
                const activeConsultants = response.filter(c => c.active);
                this.consultants = [...activeConsultants];
                this.centerConsultants = this.commonHelper.getDropDownListItems(
                    this.consultants,
                    '_id',
                    'name'
                );
                this.loading = false;
            } else {
                this.errorHandler.interceptError(response, 'Consultor')
                this.loading = false;
            }
            return;
        } catch (error) {
            this.errorHandler.interceptError(error, 'Consultor')
            this.loading = false;
        }
    }

    onChangeConsultant(): void {
        if (this.selectedCenterConsultants.length) {
            this.isConsultantsEmpty = false;
            return;
        }
        this.isConsultantsEmpty = true;
    }

    async verifySelectedCenter(): Promise<Toast | void> {
        if (this.selectedCenter === 'undefined' || this.selectedCenter === '' ||
         this.selectedCenter === undefined) {
            return await this.toastr.warning('Selecione um Centro de Excelência para poder realizar o disparo em massa de formulários', 'Seletor inválido');
        }
        this.massFormRequest.nativeElement.click();
    }

    async sendSelfFillRequests(): Promise<Toast> {
        try {
            this.loading = true;
            if (this.selectedCenterConsultants && this.selectedCenterConsultants.length) {
                const ids = this.selectedCenterConsultants.map(({id}) => id)
                const response = await this.consultantService.sendMassRequest({consultants: ids});
                if (response && response.success) {
                    this.clearFields();
                    this.loading = false;
                    return this.toastr.success('Formulários de Auto Cadastro foram enviados com sucesso!', 'Módulo Consultor');
                }
            }
            this.loading = false;
            this.clearFields();
        } catch (error) {
            this.loading = false;
            this.errorHandler.interceptError(error, 'Consultor')
        }
    }

    selectAllConsultantsFromCenter() {
        if (this.isMassRequest) {
            if (this.centerConsultants && this.centerConsultants.length) {
                this.selectedCenterConsultants = this.centerConsultants.map(({id, itemName}) => {
                    return {
                        id,
                        itemName
                    }
                });
            }
            return;
        }
        this.selectedCenterConsultants = [];
    }

    clearFields(): void {
        this.selectedCenter = 'undefined';
        this.centerConsultants = [];
        this.selectedCenterConsultants = [];
        this.isMassRequest = false;
        this.isAnyCenterSelected = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/self-fill-modal/self-fill-modal.component.ts